import React, { useId } from 'react';

// Las dos cosas que se manejan desde aquí, dibujadas como son: la santamaría (cortina de
// láminas que se enrolla en su caja) y la puerta de ascensor (dos hojas que se corren).
// El estado se ve en el dibujo; las transiciones viven en puertas.css y se apagan con
// movimiento reducido.

const LAMINAS = 15;

export const Santamaria = ({ abierta, apagada }) => {
    const id = useId().replace(/:/g, '');
    return (
    <svg viewBox="0 0 360 190" className={`w-full h-full ${apagada ? 'opacity-50' : ''}`} role="img"
        aria-label={abierta ? 'Santamaría abierta' : 'Santamaría cerrada'}>
        <defs>
            <linearGradient id={`sm-adentro-${id}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#E0F2FE" />
                <stop offset="1" stopColor="#F0F9FF" />
            </linearGradient>
            <linearGradient id={`sm-lamina-${id}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#CBD5E1" />
                <stop offset="0.45" stopColor="#E9EEF4" />
                <stop offset="1" stopColor="#B8C4D3" />
            </linearGradient>
            <linearGradient id={`sm-caja-${id}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#E2E8F0" />
                <stop offset="1" stopColor="#CBD5E1" />
            </linearGradient>
            <clipPath id={`sm-vano-${id}`}><rect x="70" y="44" width="220" height="126" /></clipPath>
        </defs>

        {/* Lo de adentro: se ve cuando sube la cortina */}
        <rect x="70" y="44" width="220" height="126" fill={`url(#sm-adentro-${id})`} />
        <g stroke="#BAE6FD" strokeWidth="1">
            <line x1="70" y1="170" x2="140" y2="118" />
            <line x1="290" y1="170" x2="220" y2="118" />
            <line x1="140" y1="118" x2="220" y2="118" />
            <line x1="180" y1="170" x2="180" y2="118" strokeDasharray="3 4" />
        </g>

        {/* La cortina: láminas que se enrollan en la caja */}
        <g clipPath={`url(#sm-vano-${id})`}>
            <g className={`santamaria-cortina ${abierta ? 'arriba' : ''}`}>
                {Array.from({ length: LAMINAS }, (_, i) => (
                    <g key={i}>
                        <rect x="70" y={44 + i * 8} width="220" height="7.4" fill={`url(#sm-lamina-${id})`} />
                        <line x1="70" y1={44 + i * 8 + 3.7} x2="290" y2={44 + i * 8 + 3.7} stroke="#AFBCCB" strokeWidth="0.6" />
                    </g>
                ))}
                <rect x="70" y="163" width="220" height="7" fill="#64748B" />
                <rect x="170" y="164.5" width="20" height="4" rx="2" fill="#CBD5E1" />
            </g>
        </g>

        {/* Pilares, caja y piso */}
        <rect x="40" y="30" width="30" height="140" fill="#FFFFFF" stroke="#CBD5E1" />
        <rect x="290" y="30" width="30" height="140" fill="#FFFFFF" stroke="#CBD5E1" />
        <rect x="62" y="22" width="236" height="22" rx="6" fill={`url(#sm-caja-${id})`} stroke="#94A3B8" />
        <line x1="20" y1="170.5" x2="340" y2="170.5" stroke="#94A3B8" strokeWidth="1.5" />

        {/* Lector y luz de estado */}
        <rect x="299" y="96" width="12" height="20" rx="2.5" fill="#E2E8F0" stroke="#94A3B8" />
        <circle cx="305" cy="102" r="2.6" className={`santamaria-luz ${abierta ? 'encendida' : ''}`} />
    </svg>
    );
};

const Candado = () => (
    <g transform="translate(120 104)">
        <circle r="15" fill="#FFFFFF" stroke="#CBD5E1" />
        <path d="M-5 -1 v-4 a5 5 0 0 1 10 0 v4" fill="none" stroke="#334155" strokeWidth="2" strokeLinecap="round" />
        <rect x="-7" y="-1" width="14" height="10" rx="2" fill="#334155" />
    </g>
);

export const Ascensor = ({ abierto, bloqueado, apagado, piso }) => {
    const id = useId().replace(/:/g, '');
    return (
    <svg viewBox="0 0 240 190" className={`w-full h-full ${apagado ? 'opacity-50' : ''}`} role="img"
        aria-label={abierto ? 'Puerta del ascensor abierta' : 'Puerta del ascensor cerrada'}>
        <defs>
            <linearGradient id={`as-cabina-${id}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#E0F2FE" />
                <stop offset="1" stopColor="#BAE6FD" />
            </linearGradient>
            <linearGradient id={`as-acero-${id}`} x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor="#D5DEE8" />
                <stop offset="0.5" stopColor="#F4F7FA" />
                <stop offset="1" stopColor="#C9D3DF" />
            </linearGradient>
            <clipPath id={`as-vano-${id}`}><rect x="62" y="44" width="116" height="126" /></clipPath>
        </defs>

        {/* Indicador del piso */}
        <rect x="96" y="14" width="48" height="22" rx="6" fill="#0B1E3A" />
        <text x="120" y="29.5" textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="700" fontSize="12" fill="#22D3EE">
            {piso ? `P${piso}` : ''}
        </text>

        {/* La cabina, detrás de las hojas */}
        <rect x="62" y="44" width="116" height="126" fill={`url(#as-cabina-${id})`} />
        <line x1="70" y1="120" x2="170" y2="120" stroke="#7DD3FC" strokeWidth="2" strokeLinecap="round" />
        <ellipse cx="120" cy="50" rx="34" ry="4" fill="#FFFFFF" opacity="0.8" />

        {/* Las hojas se corren hacia los lados */}
        <g clipPath={`url(#as-vano-${id})`}>
            <g className={`ascensor-hoja izquierda ${abierto ? 'abierta' : ''}`}>
                <rect x="62" y="44" width="58" height="126" fill={`url(#as-acero-${id})`} stroke="#A3B1C2" strokeWidth="0.8" />
            </g>
            <g className={`ascensor-hoja derecha ${abierto ? 'abierta' : ''}`}>
                <rect x="120" y="44" width="58" height="126" fill={`url(#as-acero-${id})`} stroke="#A3B1C2" strokeWidth="0.8" />
            </g>
        </g>

        {/* Marco, pared y lector */}
        <rect x="59" y="41" width="122" height="130" rx="3" fill="none" stroke="#94A3B8" strokeWidth="4" />
        <line x1="20" y1="171" x2="220" y2="171" stroke="#94A3B8" strokeWidth="1.5" />
        <rect x="192" y="92" width="14" height="26" rx="3" fill="#E2E8F0" stroke="#94A3B8" />
        <circle cx="199" cy="100" r="2.6" className={`santamaria-luz ${abierto ? 'encendida' : ''}`} />
        {bloqueado && <Candado />}
    </svg>
    );
};
